// Navigation moved to Header hamburger menu
export function BottomNav() {
  return null;
}
